<form [formGroup]="workOrderFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            label="Workorder Numbers"
            placeholder="Enter workorder number(s)"
            [regex]="workorderRegex"
            formControlName="woNumber"
            data-cy="workorder-numbers"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            label="Equipment Numbers"
            placeholder="Enter equipment number(s)"
            [regex]="equipmentNumberRegex"
            formControlName="equipmentId"
            data-cy="equipment-numbers"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Mode" fit="medium" width="100" placeholder="Select an Option" ngDefaultControl formControlName="mode">
            @for (mode of modes; track mode.code) {
              <mc-option [attr.data-cy]="mode.code" [value]="mode">{{ mode.code }} {{ mode.description }}</mc-option>
            }
          </mc-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-multi-select label="Status" fit="medium" width="100" placeholder="Select an Option" ngDefaultControl formControlName="status">
            @for (status of statuses; track status.generatedCode) {
              <mc-option [attr.data-cy]="status.description" [value]="status">{{ status.description }}</mc-option>
            }
          </mc-multi-select>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input-date
            label="From"
            startofweek="1"
            format="DD-MM-YYYY"
            nextlabel="Next month"
            previouslabel="Previous month"
            placeholder="DD-MM-YYYY"
            width="auto"
            ngDefaultControl
            formControlName="fromDate"
            data-cy="from-date">
          </mc-input-date>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <mc-input-date
            label="To"
            startofweek="1"
            format="DD-MM-YYYY"
            nextlabel="Next month"
            previouslabel="Previous month"
            placeholder="DD-MM-YYYY"
            width="auto"
            ngDefaultControl
            formControlName="toDate"
            data-cy="to-date">
          </mc-input-date>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16">
          <app-aems-multiline-tag-input
            label="Shop Id(s)"
            [transformToUppercase]="true"
            placeholder="Enter shop Id(s)"
            [regex]="shopIdRegex"
            formControlName="shop"></app-aems-multiline-tag-input>
        </div>
        <div class="pure-u-md-12-24 p-b-16 p-r-16 m-t-36">
          <mc-checkbox
            [checked]="workOrderFilterForm.controls.showFlaggedWO.value"
            name="showFlaggedWO"
            label="Show only flagged work orders"
            ngDefaultControl
            formControlName="showFlaggedWO"
            data-cy="is-flagged">
          </mc-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
